<app-header></app-header>
<div class="container-fluid">
  @if (article) {
    <div>
      <h2>{{id}}</h2>
      <hr>
        <dl fxLayout="column">
          <div fxLayout="row" fxLayout.lt-md="column">
            <dt fxFlex="25">Paper Title:</dt>
            <dd fxFlex="75">{{article['title']}}</dd>
          </div>
          <div fxLayout="row" fxLayout.lt-md="column">
            <dt fxFlex="25">Author(s):</dt>
            <dd fxFlex="75">{{article['authorString']}}</dd>
          </div>
          @if (article['journal']) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Journal Name:</dt>
              <dd fxFlex="75">{{article['journal']}}</dd>
            </div>
          }
          @if (article['issue']) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Journal Issue:</dt>
              <dd fxFlex="75">{{article['issue']}}</dd>
            </div>
          }
          @if (article['volume']) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Journal Volume:</dt>
              <dd fxFlex="75">{{article['volume']}}
              </dd>
            </div>
          }
          @if (article['pages']) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Journal Page:</dt>
              <dd fxFlex="75">{{article['pages']}}
              </dd>
            </div>
          }
          @if (article['pmcId']) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Europe PMC:</dt>
              <dd fxFlex="75">
                <app-robust-link [prefix]="epmc_prefix" [link]="article['pmcId']"
                [text]="article['pmcId']"></app-robust-link>
              </dd>
            </div>
          }
          @if (article['pubmedId']) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">PubMed:</dt>
              <dd fxFlex="75">
                <app-robust-link [prefix]="pubmed_prefix" [link]="article['pubmedId']"
                [text]="article['pubmedId']"></app-robust-link>
              </dd>
            </div>
          }
          @if (article['doi']) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">DOI:</dt>
              <dd fxFlex="75">
                <app-robust-link [prefix]="doi_prefix" [link]="article['doi']"
                [text]="article['doi']"></app-robust-link>
              </dd>
            </div>
          }
          @if (article['datasetSource']) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Dataset source:</dt>
              <dd fxFlex="75">{{article['datasetSource']}}</dd>
            </div>
          }
          @if (article['source']) {
            <div fxLayout="row" fxLayout.lt-md="column">
              <dt fxFlex="25">Article Type:</dt>
              <dd fxFlex="75">{{article.source.toUpperCase() !== 'PPR' ? 'published' : 'preprint'}}</dd>
            </div>
          }
        </dl>
        <app-related-items source_type="publication" target_type="dataset" [data]="relatedDatasets"
        download_key="" [record_id]="id"></app-related-items>
      </div>
    }
    @if (error) {
      <div class="alert alert-danger"><p>{{ error }}</p></div>
    }
  </div>
